// https://github.com/MLaritz/Vanilla-Notify
enum NotifyPosition {
    topLeft = 'topLeft',
    topRight = 'topRight',
    bottomLeft = 'bottomLeft',
    bottomRight = 'bottomRight',
    center = 'center'
};

const DEFAULT_OPTIONS = {
    title: '',
    text: '',
    class: '',
        fadeInDuration: 500,
        fadeOutDuration: 500,
        fadeInterval: 50,
        visibleDuration: 5000,
        postHoverVisibleDuration: 500,
    position: NotifyPosition.bottomRight as NotifyPosition,
        sticky: false,
        showClose: true
    };

type NotifyParams = Partial<typeof DEFAULT_OPTIONS>;

export class Notify {

    constructor(params:NotifyParams) {
        var frag = document.createDocumentFragment();

        var item:any = {};

        item.element=document.createElement('div');
        item.element.classList.add('notify-item');
        item.element.classList.add(params.class);
        item.element.style.opacity = 0;

        item.options = { ...DEFAULT_OPTIONS, ...params };

        if (params.title) {
            item.element.appendChild(this.addTitle(params.title));
        }

        if (params.text) {
            item.element.appendChild(this.addText(params.text));
        }

        if (item.options.showClose) {
            item.element.appendChild(this.addClose(item));
        }

        item.visibleDuration = item.options.visibleDuration; //option

        var hideNotify = ()=>{
            item.fadeInterval = this.fade('out', item.options.fadeOutDuration, item.options.fadeInterval, item.element);
        };

        var resetInterval = function() {
            clearTimeout(item.interval);
            clearTimeout(item.fadeInterval);
            item.element.style.opacity = null;
            item.visibleDuration = item.options.postHoverVisibleDuration;
        };

        var hideTimeout = function () {
            item.interval = setTimeout(hideNotify, item.visibleDuration);
        };

        frag.appendChild(item.element);
        var container = this.getNotifyContainer(item.options.position);
        container.appendChild(frag);

        item.element.addEventListener("mouseover", resetInterval);

        this.fade('in', item.options.fadeInDuration, item.options.fadeInterval, item.element);

        if (!item.options.sticky){
            item.element.addEventListener("mouseout", hideTimeout);
            hideTimeout();
        }
    };

    private addText(text:string) {
        var item = document.createElement('div');
        item.classList.add('notify-text');
        item.innerHTML = text;
        return item;
    };

    private addTitle(title:string) {
        var item = document.createElement('div');
        item.classList.add('notify-title');
        item.innerHTML = title;
        return item;
    };

    private addClose(parent:any) {
        var item = document.createElement('span');
        item.classList.add('notify-close');
        item.addEventListener('click', ()=>{this.remove(parent.element);});
        return item;
    };

    private getNotifyContainer(position:NotifyPosition) {
        var positionClass = this.getPositionClass(position);
        var container = document.querySelector('.' + positionClass);
        return container ? container : this.createNotifyContainer(positionClass);
    };

    private createNotifyContainer(positionClass:string) {
        var frag = document.createDocumentFragment();
        var container = document.createElement('div');
        container.classList.add('notify-container');
        container.classList.add(positionClass);
        container.setAttribute('role', 'alert');

        frag.appendChild(container);
        document.body.appendChild(frag);

        return container;
    };

    private getPositionClass(option:NotifyPosition) {
        switch (option) {
            case NotifyPosition.topLeft:
                return 'notify-top-left';
            case NotifyPosition.bottomRight:
                return 'notify-bottom-right';
            case NotifyPosition.bottomLeft:
                return 'notify-bottom-left';
            case NotifyPosition.center:
                return 'notify-center';
            default:
                return 'notify-top-right';
        }
    };

    private remove(item:HTMLElement) {
        item.style.display = 'none';
        item.outerHTML = '';
    };

    //New fade - based on http://toddmotto.com/raw-javascript-jquery-style-fadein-fadeout-functions-hugo-giraudel/
    private fade(type:'in'|'out', fadeDuration:number, fadeInterval:number, el:HTMLElement) {
        var isIn = type === 'in',
        opacity = isIn ? 0 : parseInt(el.style.opacity) || 1,
        goal = isIn ? 1 : 0,
        gap = fadeInterval / fadeDuration;

        if(isIn) {
            el.style.display = 'block';
            el.style.opacity = String(opacity);
        }

        var func=()=>{
            opacity = isIn ? opacity + gap : opacity - gap;
            el.style.opacity = String(opacity);

            if((!isIn && opacity <= goal) || (isIn && opacity >= goal)) {
                window.clearInterval(fading);
            }

            if(opacity <= 0) {
                this.remove(el);
                this.checkRemoveContainer();
            }
        }

        var fading = window.setInterval(func, fadeInterval);
        return fading;
    };

    private checkRemoveContainer() {
        var item = document.querySelector('.notify-item');
        if (!item) {
            var container = document.querySelectorAll('.notify-container');
            for (var i=0; i< container.length; i++) {
                container[i].remove();
            }
        }
    }
}

export {};